import React, { useState } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText
} from '@material-ui/core';

const CancelButton = () => {
  const [open, setOpen] = useState(false)

  const cancelRegistration = () => {
    setOpen(false)
    window.location.href='/users/sign_in'
  }

  return(
    <div>
      <Button
        variant='contained'
        onClick={() => setOpen(true)}
        color='secondary'
      >
        Cancel
      </Button>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to cancel registration?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} color="primary" autoFocus>
            No
          </Button>
          <Button onClick={cancelRegistration} color="primary">
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default CancelButton
